(function () {
  'use strict';

  function initRoot(root) {
    if (root._kjxrInit) return;
    root._kjxrInit = true;

    var SECTION_ID = root.getAttribute('data-section-id');
    var PRODUCT_ID = root.getAttribute('data-product-id');
    var VARIANT_ID = root.getAttribute('data-variant-id');
    var API_BASE = root.getAttribute('data-api-base') || 'https://home-5017198992.app-ionos.space';
    var STORAGE = API_BASE + '/storage/app/public';
    var FALLBACK = 'https://cdn.shopify.com/s/files/1/0613/9215/8858/files/image_9.png?v=1738392030';

    function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');}
    function imgUrl(v, folder){if(!v) return FALLBACK; if(/^https?:\/\//i.test(v)) return v; return STORAGE + '/' + folder + '/' + v;}
    function prizeDesc(item){var d=String(item.description||item.f_description||'').trim(); if(item.size||item.f_size){d=d.replace(/^größe:\s*[^\n]+\n?/i,'').trim();} return d;}
    function prizeVariants(item){
      if(Array.isArray(item.variants) && item.variants.length > 1){
        return item.variants.map(function(v){
          return { number: v.number, img: imgUrl(v.image_url || v.image, 'lottery_variants') };
        }).filter(function(v){ return v.img && v.img !== FALLBACK; });
      }
      return [];
    }
    function prizeVariantImages(item, mainImg){
      var seen = {};
      var images = [];
      function add(src){
        if(!src || src === FALLBACK || seen[src]) return;
        seen[src] = true;
        images.push(src);
      }
      add(mainImg);
      if(Array.isArray(item.variant_images)){
        item.variant_images.forEach(function(url){
          add(/^https?:\/\//i.test(url) ? url : imgUrl(url, 'lottery_variants'));
        });
      } else if(Array.isArray(item.variants) && item.variants.length === 1){
        var v = item.variants[0];
        add(imgUrl(v.image_url || v.image, 'lottery_variants'));
      }
      return images;
    }
    function variantTagHTML(p){
      var list = Array.isArray(p.variants) ? p.variants.filter(function(v){ return v && v.img; }) : [];
      var hasMultiple = list.length > 1 || (parseInt(p.variant_count, 10) > 1);
      if(!hasMultiple) return '';
      var choosable = list.length > 1
        && p.variants_selectable !== false
        && p.variants_selectable !== 0
        && p.variants_selectable !== '0';
      var type = choosable ? 'choosable' : 'random';
      var label = choosable ? 'Wählbar' : 'Zufällig';
      return '<span class="kjxr-ovvpill kjxr-ovvpill--'+type+'">'+label+'</span>';
    }
    function variantItems(p){
      var selectable = Array.isArray(p.variants) ? p.variants.filter(function(v){ return v && v.img; }) : [];
      var items = [];
      if(selectable.length > 1){
        items.push({ src: p.img, label: 'Hauptbild' });
        selectable.forEach(function(v){
          items.push({ src: v.img, label: 'Variante ' + (v.number || '') });
        });
      } else if(Array.isArray(p.gallery) && p.gallery.length > 1){
        items = p.gallery.map(function(src, gi){
          return { src: src, label: 'Bild ' + (gi + 1) };
        });
      }
      return items;
    }
    function variantStripHTML(p){
      var items = variantItems(p);
      if(!items.length) return '';
      var thumbs = items.map(function(it, ti){
        return '<button type="button" class="kjxr-ovthumb-btn'+(ti===0?' is-active':'')+'" data-src="'+esc(it.src)+'" aria-label="'+esc(it.label)+'">'
          + '<img src="'+esc(it.src)+'" alt="" loading="lazy">'
          + '</button>';
      }).join('');
      return '<div class="kjxr-ovvariants" data-kjxr-stop>'
        + '<div class="kjxr-ovvariants-head">'
        + '<span class="kjxr-ovvariants-lbl">Varianten</span>'
        + variantTagHTML(p)
        + '</div>'
        + '<div class="kjxr-ovstrip">'+thumbs+'</div>'
        + '</div>';
    }

    var prizes = [];
    var $ = function(id){ return document.getElementById(id); };
    var q = function(sel){ return root.querySelector(sel); };

    var LOW_RATIO = 1/3;
    function isLow(p){ return p.total > 0 && (p.left / p.total) <= LOW_RATIO; }

    function ovStatus(p){
      if(p.last) return p.left>0 ? {cls:'kjxr-st-green',txt:'Verfügbar'} : {cls:'kjxr-st-out',txt:'Vergeben'};
      var txt = p.left+' / '+p.total+' übrig';
      if(p.left===0) return {cls:'kjxr-st-out',txt:txt};
      if(isLow(p)) return {cls:'kjxr-st-low',txt:txt};
      return {cls:'kjxr-st-green',txt:txt};
    }
    function detailStatus(p){
      if(p.last) return p.left>0 ? {cls:'kjxr-cc-green',txt:'Verfügbar'} : {cls:'kjxr-cc-out',txt:'Vergeben'};
      var txt = p.left+' / '+p.total+' übrig';
      if(p.left===0) return {cls:'kjxr-cc-out',txt:txt};
      if(isLow(p)) return {cls:'kjxr-cc-low',txt:txt};
      return {cls:'kjxr-cc-green',txt:txt};
    }

    function maybeTapHint(grid){
      var seen = false;
      try{ seen = localStorage.getItem('kjxrTapSeen')==='1'; }catch(e){}
      if(seen) return;
      if(!window.matchMedia('(max-width:640px)').matches) return;
      if(!('IntersectionObserver' in window)) return;
      var first = grid.querySelector('.kjxr-ovcard');
      if(!first) return;
      var io = new IntersectionObserver(function(entries){
        for(var i=0;i<entries.length;i++){
          if(!entries[i].isIntersecting) continue;
          io.disconnect();
          try{ localStorage.setItem('kjxrTapSeen','1'); }catch(e){}
          first.classList.add('kjxr-tap-hint');
          var thumb = first.querySelector('.kjxr-ovthumb') || first;
          var pill = document.createElement('span');
          pill.className = 'kjxr-taphint-pill';
          pill.textContent = 'Für Details antippen';
          thumb.appendChild(pill);
          setTimeout(function(){
            first.classList.remove('kjxr-tap-hint');
            if(pill.parentNode) pill.parentNode.removeChild(pill);
          }, 6200);
          return;
        }
      }, { threshold: 0.6 });
      io.observe(first);
    }

    function buildOverview(){
      var grid = $('kjxrOvGrid');
      if(!grid) return;
      grid.innerHTML = prizes.map(function(p,i){
        var s = ovStatus(p);
        var sizeHTML = p.size
          ? '<span class="kjxr-ovsize">'+esc(p.size)+'</span>'
          : '';
        var descHTML = '';
        if(p.desc){
          descHTML = '<div class="kjxr-ovdesc-wrap" data-kjxr-stop>'
            + '<p class="kjxr-ovdesc">'+esc(p.desc).replace(/\n/g,'<br>')+'</p>'
            + '<button type="button" class="kjxr-ovdesc-more" hidden>Mehr lesen</button>'
            + '</div>';
        }
        return '<article class="kjxr-ovcard'+(p.left===0&&!p.last?' out':'')+(p.last?' lastone':'')+'" data-left="'+p.left+'" data-idx="'+i+'" role="button" tabindex="0">'
          + '<div class="kjxr-ovthumb"><img loading="lazy" src="'+esc(p.img)+'" alt="'+esc(p.name)+'"></div>'
          + '<div class="kjxr-ovbody">'
          + '<div class="kjxr-ovmeta">'
          + '<div class="kjxr-ovletter">'+esc(p.l)+'<em>'+(p.last?'ONE':'賞')+'</em></div>'
          + sizeHTML
          + '</div>'
          + '<div class="kjxr-ovname">'+esc(p.name)+'</div>'
          + descHTML
          + variantStripHTML(p)
          + '<div class="kjxr-ovcount '+s.cls+'"><span class="d"></span>'+s.txt+'</div>'
          + '</div></article>';
      }).join('');

      grid.querySelectorAll('.kjxr-ovcard').forEach(function(c){
        function open(){ openModal(parseInt(c.getAttribute('data-idx'),10)); }
        c.addEventListener('click', function(e){
          if(e.target.closest('[data-kjxr-stop]')) return;
          open();
        });
        c.addEventListener('keydown', function(e){
          if(e.key === 'Enter' || e.key === ' '){
            if(e.target.closest('[data-kjxr-stop]')) return;
            e.preventDefault();
            open();
          }
        });
      });

      grid.querySelectorAll('.kjxr-ovdesc-wrap').forEach(function(wrap){
        var desc = wrap.querySelector('.kjxr-ovdesc');
        var btn = wrap.querySelector('.kjxr-ovdesc-more');
        if(!desc || !btn) return;
        if(desc.scrollHeight > desc.clientHeight + 4){ btn.hidden = false; }
        btn.addEventListener('click', function(e){
          e.stopPropagation();
          var expanded = wrap.classList.toggle('is-expanded');
          btn.textContent = expanded ? 'Weniger' : 'Mehr lesen';
        });
      });

      grid.querySelectorAll('.kjxr-ovvariants').forEach(function(rail){
        var card = rail.closest('.kjxr-ovcard');
        var main = card && card.querySelector('.kjxr-ovthumb img');
        rail.querySelectorAll('.kjxr-ovthumb-btn').forEach(function(btn){
          btn.addEventListener('click', function(e){
            e.stopPropagation();
            var src = btn.getAttribute('data-src');
            if(main && src) main.src = src;
            rail.querySelectorAll('.kjxr-ovthumb-btn').forEach(function(b){ b.classList.remove('is-active'); });
            btn.classList.add('is-active');
          });
        });
      });

      maybeTapHint(grid);
    }

    var ticketsAnimStarted = false;

    function paintTicketVals(leftInv, totalInv){
      var pct = totalInv>0 ? Math.round((leftInv/totalInv)*100) : 0;
      var l = $('kjxrLoseLeft'); if(l) l.textContent = leftInv;
      var p = $('kjxrPct'); if(p) p.textContent = pct+'%';
      var bar = $('kjxrBar'); if(bar) bar.style.width = pct+'%';
    }

    function runTicketCountdown(leftInv, totalInv){
      var l = $('kjxrLoseLeft'), p = $('kjxrPct'), bar = $('kjxrBar');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      if(reduce || !l || totalInv<=0 || leftInv>=totalInv){ paintTicketVals(leftInv, totalInv); return; }
      var span = totalInv - leftInv;
      var dur = Math.max(700, Math.min(1600, 420 + span*14));
      var t0 = 0;
      if(bar) bar.style.transition = 'none';
      function frame(ts){
        if(!t0) t0 = ts;
        var k = Math.min(1, (ts-t0)/dur);
        var e = 1 - Math.pow(1-k, 3);
        var cur = Math.round(totalInv - span*e);
        var pct = Math.round((cur/totalInv)*100);
        l.textContent = cur;
        if(p) p.textContent = pct+'%';
        if(bar) bar.style.width = pct+'%';
        if(k < 1){ requestAnimationFrame(frame); return; }
        if(bar) bar.style.transition = '';
        paintTicketVals(leftInv, totalInv);
        l.classList.add('is-landed');
        setTimeout(function(){ l.classList.remove('is-landed'); }, 520);
      }
      requestAnimationFrame(frame);
    }

    function scheduleTicketCountdown(leftInv, totalInv){
      var panel = q('.kjxr-avail');
      function run(){
        if($('kjxrLoseLeft')) $('kjxrLoseLeft').textContent = totalInv;
        if($('kjxrPct')) $('kjxrPct').textContent = '100%';
        if($('kjxrBar')) $('kjxrBar').style.width = '100%';
        runTicketCountdown(leftInv, totalInv);
      }
      if(!panel || !('IntersectionObserver' in window)){ run(); return; }
      var r = panel.getBoundingClientRect();
      if(r.top < window.innerHeight && r.bottom > 0){ run(); return; }
      var io = new IntersectionObserver(function(entries){
        for(var i=0;i<entries.length;i++){
          if(!entries[i].isIntersecting) continue;
          io.disconnect();
          run();
          return;
        }
      }, { threshold: 0.4 });
      io.observe(panel);
    }

    function paintTickets(leftInv, totalInv){
      var t = $('kjxrLoseTotal'); if(t) t.textContent = totalInv;
      var l = $('kjxrLoseLeft');
      if(l && totalInv>0) l.style.minWidth = String(totalInv).length + 'ch';
      var sb = $('kjxrSbLeft'); if(sb) sb.textContent = leftInv>0 ? 'Noch '+leftInv+' Lose übrig' : 'Ausverkauft';
      var addBtn = $('kjxrAddBtn');
      if(addBtn && leftInv<=0){ addBtn.setAttribute('disabled','disabled'); addBtn.textContent='Ausverkauft'; }

      var bar = $('kjxrBar');
      var low = totalInv > 0 && (leftInv / totalInv) <= LOW_RATIO;
      if(bar) bar.classList.toggle('is-low', low);
      if(l) l.classList.toggle('is-low', low);

      paintTicketVals(leftInv, totalInv);
      if(ticketsAnimStarted) return;
      ticketsAnimStarted = true;
      scheduleTicketCountdown(leftInv, totalInv);
    }

    var modal = $('kjxrModal');
    var sheet = $('kjxrSheet');
    var hint = $('kjxrHint');
    var current = 0;
    var swipeSeen = false;
    try{ swipeSeen = localStorage.getItem('kjxrSwipeSeen')==='1'; }catch(e){}

    var mVariants = null;
    function ensureMVariants(){
      if(mVariants) return mVariants;
      var body = sheet && sheet.querySelector('.kjxr-mbody');
      if(!body) return null;
      mVariants = document.createElement('div');
      mVariants.className = 'kjxr-mvariants';
      mVariants.setAttribute('data-kjxr-noswipe','');
      body.insertBefore(mVariants, body.firstChild);
      mVariants.addEventListener('click', function(e){
        var btn = e.target.closest('.kjxr-mthumb-btn');
        if(!btn) return;
        var src = btn.getAttribute('data-src');
        var img = $('kjxrMImg');
        if(img && src) img.src = src;
        mVariants.querySelectorAll('.kjxr-mthumb-btn').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
      mVariants.addEventListener('scroll', function(e){
        if(e.target && e.target.classList.contains('kjxr-mvstrip')) updateStripEdges(e.target);
      }, true);
      return mVariants;
    }
    function updateStripEdges(strip){
      if(!strip) return;
      var max = strip.scrollWidth - strip.clientWidth;
      strip.classList.toggle('can-l', strip.scrollLeft > 4);
      strip.classList.toggle('can-r', max > 4 && strip.scrollLeft < max - 4);
    }
    function renderMVariants(p){
      var mv = ensureMVariants();
      if(!mv) return;
      var items = variantItems(p);
      if(items.length < 2){ mv.innerHTML = ''; mv.hidden = true; return; }
      var thumbs = items.map(function(it, ti){
        return '<button type="button" class="kjxr-mthumb-btn'+(ti===0?' is-active':'')+'" data-src="'+esc(it.src)+'" aria-label="'+esc(it.label)+'">'
          + '<img src="'+esc(it.src)+'" alt="" loading="lazy">'
          + '</button>';
      }).join('');
      mv.innerHTML = '<div class="kjxr-mvhead">'
        + '<span class="kjxr-mvlbl">'+items.length+' Motive</span>'
        + variantTagHTML(p)
        + '</div>'
        + '<div class="kjxr-mvstrip">'+thumbs+'</div>';
      mv.hidden = false;
      var strip = mv.querySelector('.kjxr-mvstrip');
      if(strip){
        strip.scrollLeft = 0;
        updateStripEdges(strip);
        requestAnimationFrame(function(){ updateStripEdges(strip); });
      }
    }

    function renderModal(i){
      var p = prizes[i]; if(!p) return; current = i;
      var s = detailStatus(p);
      sheet.classList.toggle('out', p.left===0 && !p.last);
      sheet.classList.toggle('lastone', !!p.last);
      $('kjxrMImg').src = p.img;
      $('kjxrMImg').alt = p.name;
      $('kjxrMLetter').innerHTML = esc(p.l)+'<em>'+(p.last?'ONE':'賞')+'</em>';
      var sizeEl = $('kjxrMSize');
      sizeEl.textContent = p.size || ''; sizeEl.style.display = p.size ? '' : 'none';
      $('kjxrMName').textContent = p.name;
      $('kjxrMDesc').innerHTML = p.desc ? esc(p.desc).replace(/\n/g,'<br>') : '';
      renderMVariants(p);
      var c = $('kjxrMCount');
      c.className = 'kjxr-count '+s.cls;
      c.innerHTML = '<span class="d"></span>'+s.txt;
    }
    function hideHint(){ if(hint && hint.classList.contains('on')){ hint.classList.add('hide'); setTimeout(function(){hint.classList.remove('on','hide');},500); } }
    function maybeHint(){
      if(swipeSeen || !hint || !window.matchMedia('(max-width:640px)').matches) return;
      swipeSeen = true; try{ localStorage.setItem('kjxrSwipeSeen','1'); }catch(e){}
      hint.classList.remove('hide'); hint.classList.add('on'); setTimeout(hideHint,3400);
    }
    function openModal(i){ renderModal(i); modal.classList.add('show'); modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; maybeHint(); }
    function closeModal(){ modal.classList.remove('show'); modal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
    function stepModal(d){ hideHint(); current=(current+d+prizes.length)%prizes.length; renderModal(current); if(sheet) sheet.scrollTop = 0; }

    if(modal){
      modal.querySelectorAll('[data-kjxr-close]').forEach(function(el){ el.addEventListener('click', closeModal); });
      modal.querySelectorAll('[data-kjxr-step]').forEach(function(el){ el.addEventListener('click', function(){ stepModal(parseInt(el.getAttribute('data-kjxr-step'),10)); }); });
      document.addEventListener('keydown', function(e){
        if(!modal.classList.contains('show')) return;
        if(e.key==='Escape') closeModal();
        if(e.key==='ArrowLeft') stepModal(-1);
        if(e.key==='ArrowRight') stepModal(1);
      });
      var tx=0,ty=0,tNoSwipe=false;
      sheet.addEventListener('touchstart', function(e){
        tx=e.touches[0].clientX; ty=e.touches[0].clientY;
        tNoSwipe = !!(e.target.closest && e.target.closest('[data-kjxr-noswipe]'));
        hideHint();
      }, {passive:true});
      sheet.addEventListener('touchend', function(e){
        if(tNoSwipe){ tNoSwipe=false; return; }
        var dx=e.changedTouches[0].clientX-tx, dy=e.changedTouches[0].clientY-ty;
        if(Math.abs(dx)>Math.abs(dy) && Math.abs(dx)>50){ stepModal(dx<0?1:-1); }
        else if(dy>90 && sheet.scrollTop<=0){ closeModal(); }
      }, {passive:true});
    }

    var toggle = q('[data-kjxr-toggle]');
    if(toggle){
      toggle.addEventListener('click', function(){
        var on = toggle.classList.toggle('on');
        root.querySelectorAll('.kjxr-ovcard').forEach(function(c){
          c.style.display = (on && parseInt(c.getAttribute('data-left'),10)===0) ? 'none' : '';
        });
      });
    }

    (function(){
      var desc = $('kjxrDesc-'+SECTION_ID);
      var more = q('[data-kjxr-descmore]');
      if(!desc || !more) return;
      if(desc.scrollHeight > desc.clientHeight + 4){ more.hidden = false; }
      more.addEventListener('click', function(){
        var expanded = desc.classList.toggle('clamp') === false;
        more.textContent = expanded ? 'Weniger lesen' : 'Mehr lesen';
      });
    })();

    var qtyInput = $('Quantity-'+SECTION_ID);
    root.querySelectorAll('[data-kjxr-qty]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if(!qtyInput) return;
        var d = parseInt(btn.getAttribute('data-kjxr-qty'),10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value,10)||1) + d);
      });
    });

    window.kjxrAddToCart = function(btn){
      if(btn.hasAttribute('disabled')) return;
      var qty = qtyInput ? (parseInt(qtyInput.value,10)||1) : 1;
      var original = btn.textContent;
      btn.disabled = true; btn.textContent = '...';
      var formData = new FormData();
      formData.append('id', VARIANT_ID);
      formData.append('quantity', qty);
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if(cart){
        formData.append('sections', cart.getSectionsToRender().map(function(s){return s.id;}));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }
      fetch('/cart/add.js', { method:'POST', headers:{'X-Requested-With':'XMLHttpRequest'}, body:formData })
        .then(function(r){ return r.json(); })
        .then(function(response){
          if(response.status){ btn.textContent = original; btn.disabled = false; return; }
          if(!cart){ window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
          if(typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'){ publish(PUB_SUB_EVENTS.cartUpdate, { source:'product-form' }); }
          cart.renderContents(response);
        })
        .catch(function(e){ console.error(e); })
        .finally(function(){ btn.textContent = original; btn.disabled = false; if(cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty'); });
    };

    function fetchData(){
      fetch(API_BASE + '/api/get-lottery-data/' + PRODUCT_ID)
        .then(function(r){ return r.json(); })
        .then(function(response){
          if(!response.status){ console.warn('No lottery data:', response.message); return; }
          var d = response.data;
          var details = [];
          try{ details = JSON.parse(d.f_details || '[]'); }catch(e){ details = []; }
          prizes = [];
          if(Array.isArray(details)){
            details.forEach(function(item, index){
              var mainImg = imgUrl(item.f_image || item.image_url, 'lottery_first');
              prizes.push({
                l: String.fromCharCode(65+index),
                name: item.f_title || 'Preis',
                size: item.size || item.f_size || '',
                img: mainImg,
                left: Number(item.unit || 0),
                total: Number(item.unitTotal || item.unit || 0),
                desc: prizeDesc(item),
                last: false,
                variants: prizeVariants(item),
                variant_count: item.variant_count,
                variants_selectable: item.variants_selectable,
                gallery: prizeVariantImages(item, mainImg)
              });
            });
          }
          if(d.l_title || d.last_image){
            var lastDesc = String(d.l_description || '').trim();
            if(d.l_size){ lastDesc = lastDesc.replace(/^größe:\s*[^\n]+\n?/i,'').trim(); }
            var lastImg = imgUrl(d.last_image || d.last_image_url, 'lottery_last');
            var lastVariants = Array.isArray(d.l_variants) && d.l_variants.length > 1
              ? d.l_variants.map(function(v){
                  return { number: v.number, img: imgUrl(v.image_url || v.image, 'lottery_variants') };
                }).filter(function(v){ return v.img && v.img !== FALLBACK; })
              : [];
            prizes.push({
              l: 'LAST', name: d.l_title || 'Last One', size: d.l_size || '',
              img: lastImg,
              left: (d.lastlot_status == 0 ? 1 : 0), total: 1, desc: lastDesc, last: true,
              variants: lastVariants,
              variant_count: d.l_variant_count,
              variants_selectable: d.l_variants_selectable,
              gallery: prizeVariantImages({ variants: d.l_variants, variant_images: d.l_variant_images }, lastImg)
            });
          }
          paintTickets(Number(response.realTimeInventory) || 0, Number(d.totalInventory) || 0);
          buildOverview();
        })
        .catch(function(e){ console.error('Error fetching lottery data:', e); });
    }

    fetchData();
    window.addEventListener('pageshow', function(e){ if(e.persisted) fetchData(); });
  }

  function boot(){ document.querySelectorAll('.kjxr[data-section-id]').forEach(initRoot); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
